/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

export type AddressLine = {
  FullAddress: string;
  SourceDesc: string;
  UniqueId: number;
};

const url = `${process.env.REACT_APP_ADDRESS_API_URL}/addresses`;

const subscriptionKey = process.env.REACT_APP_ADDRESS_API_KEY!;

export const searchAddress = async (searchString: string) => {
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": subscriptionKey,
    },
    body: JSON.stringify({
      searchString: searchString,
    }),
  });

  const data = await response.json();
  return data as AddressLine[];
  // Process the data
};
